/**
 * @generated SignedSource<<8de10d6518481f5948d78eb1a9e99c26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type docsDialogQuery$variables = {
  id: string;
};
export type docsDialogQuery$data = {
  readonly zendeskArticle: {
    readonly body: string | null;
    readonly title: string | null;
  } | null;
};
export type docsDialogQuery = {
  response: docsDialogQuery$data;
  variables: docsDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "docsDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ZendeskArticle",
        "kind": "LinkedField",
        "name": "zendeskArticle",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "docsDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ZendeskArticle",
        "kind": "LinkedField",
        "name": "zendeskArticle",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cefd021a6a2e01d9193b1e6524ee3471",
    "id": null,
    "metadata": {},
    "name": "docsDialogQuery",
    "operationKind": "query",
    "text": "query docsDialogQuery(\n  $id: ID!\n) {\n  zendeskArticle(id: $id) {\n    title\n    body\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "806d98801c972377f96ef0a7ff0871c6";

export default node;
